import React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  'data-type'?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      // Auto-format date input if type is 'date-text' (custom type for our date inputs)
      if (props['data-type'] === 'date-text') {
        let val = e.target.value.replace(/\D/g, ''); // Remove non-digits
        if (val.length > 8) val = val.slice(0, 8); // Max 8 digits (DDMMYYYY)

        // Add slashes
        if (val.length > 4) {
          val = `${val.slice(0, 2)}/${val.slice(2, 4)}/${val.slice(4)}`;
        } else if (val.length > 2) {
          val = `${val.slice(0, 2)}/${val.slice(2)}`;
        }
        
        e.target.value = val;
      }
      
      props.onChange?.(e);
    };

    return (
      <input
        type={type}
        className={cn(
          'flex h-12 w-full rounded-[6px] border border-input bg-white px-4 py-2 text-lg text-gray-700 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal/50 disabled:cursor-not-allowed disabled:opacity-50 min-w-0',
          className
        )}
        ref={ref}
        {...props}
        onChange={handleChange}
      />
    );
  }
);
Input.displayName = 'Input';

